'use client';

import { WHATSAPP_LINK } from '@/config/constants';

export default function FloatingWhatsApp() {
  return (
    <div className="floating-wa-wrapper" aria-label="WhatsApp Contact Widget">
      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-wa-btn"
        aria-label="Chat with Dr. (H.C.) Shyam Kumar on WhatsApp"
      >
        {/* Pulsing ring animation */}
        <span className="floating-wa-pulse" aria-hidden="true" />
        
        {/* Authentic WhatsApp SVG Icon */}
        <svg
          className="floating-wa-icon"
          viewBox="0 0 32 32"
          width="34"
          height="34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 2C8.268 2 2 8.268 2 16C2 18.608 2.71 21.054 3.948 23.148L2.094 29.906L9.044 28.086C11.074 29.23 13.454 29.89 16 29.89C23.732 29.89 30 23.622 30 16C30 8.268 23.732 2 16 2ZM23.364 21.656C23.056 22.524 21.848 23.238 20.894 23.444C20.244 23.582 19.398 23.684 16.544 22.502C12.898 20.99 10.542 17.29 10.36 17.048C10.18 16.806 8.882 15.08 8.882 13.298C8.882 11.516 9.79 10.648 10.122 10.308C10.454 9.968 10.846 9.878 11.122 9.878C11.332 9.878 11.514 9.888 11.668 9.896C12.11 9.914 12.332 9.94 12.624 10.64C12.988 11.516 13.882 13.702 13.992 13.928C14.102 14.154 14.178 14.426 14.03 14.722C13.882 15.018 13.774 15.148 13.584 15.37C13.394 15.592 13.196 15.772 13.008 16.012C12.808 16.236 12.59 16.474 12.822 16.872C13.054 17.27 13.856 18.578 15.038 19.63C16.56 20.984 17.808 21.418 18.25 21.602C18.692 21.786 18.956 21.752 19.214 21.456C19.472 21.16 20.322 20.16 20.618 19.744C20.914 19.328 21.21 19.388 21.608 19.536C22.006 19.684 24.138 20.736 24.58 20.958C25.022 21.18 25.318 21.29 25.428 21.474C25.538 21.658 25.428 22.38 23.364 21.656Z"
            fill="#FFFFFF"
          />
        </svg>

        {/* Hover label / tooltip */}
        <span className="floating-wa-label">
          <span className="floating-wa-status-dot" aria-hidden="true" />
          Chat on WhatsApp
        </span>
      </a>
    </div>
  );
}
